"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendToOthers = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = void 0;
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyagePicker_sidecar_1 = require("@voyage/ui-cursors/voyagePicker-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
var diveMultiplayerCursors_sidecar_1 = require("@dive/indicators/diveMultiplayerCursors-sidecar");
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.CrewSelected;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    // messageWriter.write16(m, d.multiId)
    messageWriter_sidecar_1.messageWriter.write32(m, d.crewId);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        // multiId: messageWriter.read16(m),
        crewId: messageWriter_sidecar_1.messageWriter.read32(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        // multiId: 100,
        crewId: 120,
    };
    messageWriter_sidecar_1.messageWriter.test('crew-selected', ex, write, read);
}
exports.test = test;
function process(m, isFromHost, from) {
    var msg = read(m);
    var cur = diveMultiplayerCursors_sidecar_1.diveMultiplayerCursors.findByMultiIdSafe(from);
    var cr = diveCrew_sidecar_1.diveCrew.findByIdSafe(msg.crewId);
    diveMultiplayerCursors_sidecar_1.diveMultiplayerCursors.networkRecieveSelectCrew(cur, cr);
    if (voyagePicker_sidecar_1.voyagePicker.get().selectedCrew === cr) {
        voyagePicker_sidecar_1.voyagePicker.clearSelection();
    }
}
exports.process = process;
function sendToOthers(msg) {
    websockets_sidecar_1.websockets._sendMessageToOthers(write, msg);
}
exports.sendToOthers = sendToOthers;
